import { forwardRef, useMemo } from 'react'
import { S3Bucket } from '@/types'
import { ImageUploader } from '@/ui'

interface FormTypeAssetControlProps {
  value: string | ':empty' | null
  onChange: (value: string | null) => void
}

export const FormTypeAssetControl = forwardRef<HTMLInputElement, FormTypeAssetControlProps>(function (
  { value, onChange },
  ref,
) {
  const parsedValue = useMemo(() => {
    if (value === ':empty') {
      return null
    }
    return value
  }, [value])

  return (
    <div className="rounded-md border bg-fg-secondary">
      <div className="flex justify-between p-3">
        <div className="font-medium text-text-secondary">Asset</div>
      </div>

      <div className="border-t p-3">
        <ImageUploader
          ref={ref}
          accept={{
            'image/webp': [],
            'image/png': [],
            'image/gif': [],
          }}
          bucket={S3Bucket.hub}
          value={parsedValue}
          onChange={onChange}
        />
      </div>
    </div>
  )
})
